const A = (I, _) => {
  const H = _ ? "100%" : `${I.length * 16}px`, t = _ ? `${100 / I.length}%` : "8px";
  return {
    containerHeight: H,
    barHeight: t
  };
};
export {
  A as calculateDimensions
};
//# sourceMappingURL=index.es2323.js.map
